import React from 'react';
import styled from 'styled-components';
import { Tabs, TabPane, Button, Icon } from 'components';
import DocumentsContext from './DocumentsContext';
import UploadModal from './UploadModal';

export interface DocumentsTabProps {
  hasLimitedAccess?: boolean;
}

const DocumentsTabs: React.FC<DocumentsTabProps> = ({ hasLimitedAccess }) => {
  const {
    currentTab,
    setCurrentTab,
    selectedRowKeys,
    setSelectedRowKeys,
    archive,
    restore,
  } = React.useContext(DocumentsContext);
  const [modalOpen, setModalOpen] = React.useState(false);

  const handleTabChange = (key: string) => {
    setCurrentTab(key as typeof currentTab);
    setSelectedRowKeys([]);
  };

  return (
    <StyledSubHeader>
      <Tabs type="primary" activeKey={currentTab} onChange={handleTabChange}>
        <TabPane tab="All" key="all">
          <></>
        </TabPane>
        <TabPane tab="Archived" key="archived">
          <></>
        </TabPane>
      </Tabs>
      <StyledButtonWrapper>
        {selectedRowKeys.length > 0 && (
          <>
            {currentTab === 'all' ? (
              <Button
                onClick={() => archive(selectedRowKeys)}
                icon={<Icon type="archive" width={14} />}
              >
                Archive
              </Button>
            ) : (
              <Button
                onClick={() => restore(selectedRowKeys)}
                icon={<Icon type="restore" width={14} />}
              >
                Restore
              </Button>
            )}
          </>
        )}
        <Button
          disabled={hasLimitedAccess}
          onClick={() => setModalOpen(true)}
          icon={
            <Icon
              type="antdUploadOutlined"
              width={14}
              offset={[0, -1]}
              color={hasLimitedAccess ? 'disabledColor' : 'textPrimary'}
            />
          }
        >
          Upload
        </Button>
      </StyledButtonWrapper>
      <UploadModal
        title="Upload Document"
        visible={modalOpen}
        onCancel={() => setModalOpen(false)}
      />
    </StyledSubHeader>
  );
};

const StyledSubHeader = styled.div`
  position: relative;
`;

const StyledButtonWrapper = styled.div`
  position: absolute;
  right: 25px;
  top: 0;
  height: 100%;
  display: grid;
  grid-auto-flow: column;
  grid-column-gap: 15px;
  align-items: center;
`;

export default DocumentsTabs;
